<template lang="html">
  <v-container style="text-align: center; margin-top: 5em; margin-bottom: 5em;">
    <v-container>
      <h1 class="display-2 font-weight-thin" style="text-align: left;">{{$t('PARTNER')}}</h1>
    </v-container>
    <v-layout row class="hidden-sm-and-down">
      <v-flex v-for="partner in partners">
        <v-container>
          <v-avatar tile size=200>
            <img :src='partner.img'/>
          </v-avatar>
      </v-container>
      </v-flex>
    </v-layout>
    <v-layout column class="hidden-md-and-up">
      <v-flex v-for="partner in partners">
        <v-container>
          <v-avatar tile size=200>
            <img :src='partner.img'/>
          </v-avatar>
      </v-container>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  data() {
    return {
      partners: [{
        img: require('../../public/img/bpifrance-logo250x250.png')
      }, {
        img: require('../../public/img/creativevalley.png')
      }, {
        img: require('../../public/img/business-france-logo-300x300.png')
      }, {
        img: require('../../public/img/LogoBondinnov.png')
      }, {
        img: require('../../public/img/Village logo-noir.jpg')
      } ]
    }
  }
}
</script>

<style lang="css" scoped>
</style>
